import React from 'react';
import AddTaskIcon from '../assets/icon-add-task-mobile.svg';
import EllipsisIcon from '../assets/icon-vertical-ellipsis.svg';
import MobileLogo from '../assets/logo-mobile.svg';
import ChevronIcon from '../assets/icon-chevron-down.svg';

function Header({ currentBoard, setDeleteItem, navigationOpen, setNavigationOpen }) {
    const addTaskModal = () => {
        let addTaskOverlay = document.getElementById('add-task-overlay');
        let addTaskModal = document.getElementById('add-task-modal');

        addTaskOverlay.classList.add('overlay');
        addTaskModal.classList.add('visible');
    };


    const addDeleteModal = () => {
        let addDeleteOverlay = document.getElementById('add-delete-overlay');
        let addDeleteModal = document.getElementById('add-delete-modal');

        addDeleteOverlay.classList.add('overlay');
        addDeleteModal.classList.add('visible');

        setDeleteItem('board');
    };

    return (
        <div className="header">
            <div className="header__board">
                <img className="header__logo" src={MobileLogo} alt="Kanban" />
                <div className="header__title">{currentBoard}</div>
                <button className="header__navigation" aria-label="Toggle board navigation" aria-controls="board-navigation" aria-expanded={navigationOpen} onClick={() => setNavigationOpen(!navigationOpen)}>
                    <img src={ChevronIcon} alt="" />
                </button>
            </div>

            <div className="header__actions">
                <button className="header__add-task" aria-label="Add New Task" onClick={addTaskModal}>
                    <img src={AddTaskIcon} alt="add-task-icon" />
                    <span>Add New Task</span>
                </button>
                <button className="header__delete" aria-label="Delete current board" onClick={addDeleteModal}>
                    <img src={EllipsisIcon} alt="" />
                </button>
            </div>

        </div>
    )
}

export default Header; 